import { ContextProvider } from "./Context";

const AppProvider = ({ children }) => (
  <ContextProvider>{children}</ContextProvider>
);

export default AppProvider;
